import React, { useEffect, useRef, useState } from 'react'
import MaterialTable from 'material-table';
import { ThemeProvider, createTheme } from '@mui/material';
import { Delete, Edit } from '@material-ui/icons';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { Select } from 'antd';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';
import { MAIN_URL, getApiCall, postApiCall, postFormApiCall } from '../../utils/api';
import tableIcons from '../component/MaterialIcon';

const UploadImage = () => {

  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false)

  const [data, setData] = useState([])
  const [typeList, setTypeList] = useState([])
  const [imageTypeId, setImageTypeId] = useState("")
  const [typeId, setTypeId] = useState("")

  const [imageFile, setImageFile] = useState(null)
  const imageFileInputRef = useRef(null);
  const imageTypeList = [
    {
      "id": "1",
      "name": "Category"
    },
    {
      "id": "2",
      "name": "Sub-Category"
    },
    {
      "id": "3",
      "name": "Service"
    }
  ]

  useEffect(() => {
    fetchData()
  }, [])
  const fetchData = async () => {
    setLoading(true)
    const res = await getApiCall("category/getallImage")
    
    setData(res.data);
    res.data.forEach((data, index) => { data.serial = index + 1; });
    setLoading(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    const formData = new FormData();

    formData.append('image_type', imageTypeId);
    formData.append('type_id', typeId);
    formData.append('image_file', imageFile);

    let res = {}
    res = await postFormApiCall("category/saveImage", formData)

    setLoading(false)

    if (res.error === true) {
      return Swal.fire({
        title: 'Error',
        text: res.message,
        icon: 'error'
      });
    }
    Swal.fire({
      title: 'Successful',
      text: res.message,
      icon: 'success'
    });
    if (imageFileInputRef.current) {
      imageFileInputRef.current.value = '';
    }
    setImageTypeId("")
    setTypeId("")
    setImageFile(null)
    setTypeList([]);
    fetchData()
  }

  const columns = [
    { title: "Sl. no", field: "serial" },
    {
      title: "Image Type", field: "image_type",
      render: (rowData) => {
        return (
          <>
            {rowData.image_type === 1 ? "Category" : (rowData.image_type === 2 ? "Sub-Category" : "Services")}
          </>
        )
      }
    },
    { title: "Type", field: "name" },
    {
      title: "Type", field: "image_path",
      render: (rowData) => {
    // console.log(MAIN_URL);

        return (
          <>
            <img src={MAIN_URL + rowData.image_path} height={50} width={50} /></>
        )
      }
    },

  ]


  const onTypeChange = async (val) => {
    setLoading(true)
    setImageTypeId(val);
    const formData = new FormData();

    formData.append('image_type', val);
    const res = await postFormApiCall("category/getTypeByImageType", formData)
    setLoading(false)
    if (res.error === true) {
      return Swal.fire({
        title: 'Error',
        text: res.message,
        icon: 'error'
      });
    }
    setTypeList(res.data)

  }

  const handleDelete = async (rowData) => {
    new Swal({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("category/deleteImage", { "id": rowData.id })
        if (res.error === true) {
          return Swal.fire({
            title: 'Error',
            text: res.message,
            icon: 'error'
          });
        }
        Swal.fire({
          title: 'Successful',
          text: res.message,
          icon: 'success'
        });
        fetchData()
      }
    })

  }
  return (
    <div>
      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
      <div className='content-wrapper'>

        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Banner</h4>
              </div>{/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                  <li className="breadcrumb-item active">Upload Image</li>
                </ol>
              </div>{/* /.col */}
            </div>{/* /.row */}
          </div>{/* /.container-fluid */}
        </div>


        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">Add Banner</h3>
                  </div>

                  <form onSubmit={handleSubmit}>
                    <div className="card-body">
                      <div className="row">

                        <div className="col-md-6 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">Select Image Type</label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => onTypeChange(e.target.value)}
                              required
                              value={imageTypeId}
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {imageTypeList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-6 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">Select Type</label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => setTypeId(e.target.value)}
                              required
                              value={typeId}
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {typeList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>


                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label htmlFor="classInput">Add Image</label>
                            <div class="input-group">
                              <input type="file" accept="image/*" ref={imageFileInputRef} onChange={(e) => setImageFile(e.target.files[0])} required="true" />
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>

                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary">Submit</button>
                    </div>
                  </form>

                </div>

              </div>
            </div>
          </div>
        </section >

        <section className="content">
          <div className="container-fluid">
            <ThemeProvider theme={defaultMaterialTheme}>
              <MaterialTable
                icons={tableIcons}
                title="Uploaded Images"
                columns={columns}
                data={data}
                onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
                options={{
                  exportButton: true,
                  actionsColumnIndex: -1,
                  headerStyle: {
                    backgroundColor: 'rgb(0 123 255)',
                    color: '#FFF',
                    fontSize: 18
                  },
                  rowStyle: (rowData, index) => ({
                    backgroundColor: (selectedRow === rowData.tableData.id) ? '#d3d4d1' : index % 2 !== 0 ? '#EEE' : '#FFF'
                  }),
                }}
                actions={[
                  // {
                  //   icon: () => <span style={{ color: '#5656ce' }}><Edit /></span>,
                  //   tooltip: 'Edit',
                  //   onClick: (event, rowData) => handleEdit(rowData),
                  // },
                  rowData => ({
                    icon: () => <span style={{ color: '#5656ce' }}><Delete /></span>,
                    tooltip: 'Delete',
                    onClick: (event, rowData) => handleDelete(rowData),
                  })
                ]}
              />
            </ThemeProvider>
          </div>
        </section>

      </div>
    </div>
  )
}

export default UploadImage